import { Badge, Box, ButtonBase, Typography, alpha, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  addLiveChatUnreadListener,
  getLiveChatUnreadCount,
  refreshLiveChatUnreadCount,
  resetLiveChatUnreadCount,
} from 'src/utils/liveChatUnread';
import {
  addTicketUnreadListener,
  getTicketUnreadCount,
  resetTicketUnreadCount,
} from 'src/utils/ticketUnread';
import { navMobilebar } from '../leftNavigation/config';

const FooterSection = () => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [liveChatUnread, setLiveChatUnread] = useState(getLiveChatUnreadCount);
  const [ticketUnread, setTicketUnread] = useState(getTicketUnreadCount);

  useEffect(() => addLiveChatUnreadListener(setLiveChatUnread), []);
  useEffect(() => addTicketUnreadListener(setTicketUnread), []);
  useEffect(() => {
    refreshLiveChatUnreadCount();
  }, []);

  const unreadByPath = {
    '/agent-inbox': liveChatUnread,
    '/tickets': ticketUnread,
  };
  const mobileItems = navMobilebar(translate);

  const handleNavigate = (path) => {
    if (path === '/agent-inbox') resetLiveChatUnreadCount();
    if (path === '/tickets') resetTicketUnreadCount();
    navigate(path);
  };

  return (
    <Box
      sx={{
        width: 'min(100%, 420px)',
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.max(1, mobileItems.length)}, minmax(0, 1fr))`,
        gap: 1,
      }}
    >
      {mobileItems.map((nav) => {
        const active = location.pathname === nav.path;
        const unread = unreadByPath[nav.path] || 0;

        return (
          <ButtonBase
            key={nav.path}
            onClick={() => handleNavigate(nav.path)}
            sx={{
              height: 52,
              borderRadius: 2,
              px: 1.25,
              gap: 1,
              color: active ? 'primary.main' : 'text.secondary',
              bgcolor: active ? alpha(theme.palette.primary.main, 0.12) : 'transparent',
              border: '1px solid',
              borderColor: active ? alpha(theme.palette.primary.main, 0.28) : 'transparent',
              transition: 'all 160ms ease',
              '&:active': {
                transform: 'scale(0.98)',
              },
            }}
          >
            <Badge badgeContent={unread} color="error" max={99}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  bgcolor: active ? 'primary.main' : alpha(theme.palette.text.secondary, 0.1),
                  color: active ? 'primary.contrastText' : 'text.secondary',
                  '& svg': { fontSize: 19 },
                }}
              >
                {nav.icon}
              </Box>
            </Badge>
            <Typography
              variant="caption"
              fontWeight={active ? 900 : 800}
              noWrap
              sx={{ minWidth: 0, fontSize: 12.5 }}
            >
              {nav.title}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};
export default FooterSection;
